export default "__VITE_ASSET__rjtZhntm__"